export default __webpack_public_path__ + "static/media/rabbit11.10b2482c.gif";